export default "__VITE_ASSET__1649c548__"